import script from "./ai-assistant-panel.vue?vue&type=script&setup=true&lang=js"
export * from "./ai-assistant-panel.vue?vue&type=script&setup=true&lang=js"

import "./ai-assistant-panel.vue?vue&type=style&index=0&id=00b0af7f&scoped=true&lang=css"
import "./ai-assistant-panel.vue?vue&type=style&index=1&id=00b0af7f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00b0af7f"]])

export default __exports__